import React, {Component} from 'react';
import AggregateFeedListItem from './AggregateFeedListItem';

export default class FeedList extends Component {
  render() {
    const {
      userFeed,
      eventID,
      type,
      origin,
      isSponsor,
      mergeNewPost,
      updatePostLike,
      updatePostComment,
    } = this.props;
    return (
      <div>
        {userFeed.map((singleFeed, i) => (
          <AggregateFeedListItem
            data={singleFeed}
            type={type}
            eventID={eventID}
            key={i}
            origin={origin}
            isSponsor={isSponsor}
            mergeNewPost={mergeNewPost}
            updatePostLike={updatePostLike}
            updatePostComment={updatePostComment}
          />
        ))}
      </div>
    );
  }
}
